import * as Yup from "yup"
import { transformSnakeToCamel } from "utils/transform"

export const PerformanceSchema = Yup.object()
  .transform(transformSnakeToCamel)
  .shape({
    createdLinks: Yup.number().nullable(),
    uniqueClicks: Yup.number().nullable(),
    totalClicks: Yup.number().nullable(),
    totalIncome: Yup.number().nullable(),
    totalSales: Yup.number().nullable(),
  })
